<template>
    <base-dashboard-layout :menu-options="menuOptions"></base-dashboard-layout>
</template>

<script>
import baseDashboardLayout from "./baseDashboardLayout.vue";

import { renderRouteLabel } from "../../utils/menu.js";
import { Person, Wallet, Settings } from "@vicons/ionicons5";

export default {
    name: "userCenterLayout",
    data() {
        return {
            menuOptions: [
                renderRouteLabel("/user/profile", "Profile", "profile", Person),
                renderRouteLabel(
                    "/user/finance/",
                    "Finance",
                    "finance",
                    Wallet,
                ),
                renderRouteLabel(
                    "/user/settings/",
                    "Settings",
                    "settings",
                    Settings,
                ),
            ],
        };
    },
    components: {
        baseDashboardLayout,
    },
};
</script>

<style scoped></style>
